import { GoogleGenerativeAI } from "@google/generative-ai";
// const ai = new GoogleGenerativeAI("AIzaSyCgfl0JhQm3GKR869d2gHx1Oh6BwwHobMk");

const genAI = new GoogleGenerativeAI("AIzaSyCgfl0JhQm3GKR869d2gHx1Oh6BwwHobMk");

export default async function applyAiText(
  promptText,
  inputsText,
  characterLimit = 1000,
) {
  try {
    //  / For text-only prompts, the gemini-2.5-flash model is a good choice.
    const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

    const prompt = `${promptText} Also ensure the text is less than ${characterLimit + 1} characters.
    Original Text: "${inputsText}"
    
    Revised Text:`;

    const result = await model.generateContent(prompt);
    const response = await result.response;
    const professionalText = response.text().trim();

    return professionalText;
  } catch (error) {
    console.error("Error getting data:", error);
    alert(error.message);
  }
}
